import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicKey } from '@solana/web3.js';
import { setSdkConfig as setLegacySdkConfig } from '@sly-rentals/core/legacy';
import App from './App';
import AppWalletProvider from './components/WalletProvider';
import { Toaster } from '@sly-rentals/ui';
import './index.css';

// The `@sly-rentals/core/legacy` entry returns web3.js TransactionInstructions
// (which Dynamic's signer expects), and it needs a `PublicKey` constructor
// injected once at startup so it can build those instructions without
// pulling web3.js in itself.
setLegacySdkConfig({ PublicKey });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppWalletProvider>
      <App />
      <Toaster position="top-right" offset="64px" duration={5000} closeButton />
    </AppWalletProvider>
  </React.StrictMode>
);
